import { z } from 'zod'
import { api } from '@/shared/api/client'
import { uuidSchema } from '@/shared/api/schemas'

export const EXPENSE_CATEGORY_NAME_MAX = 200

const expenseCategorySchema = z.object({
  id: uuidSchema,
  code: z.string(),
  name: z.string(),
  active: z.boolean(),
  branchIds: z.array(uuidSchema),
})

export type ExpenseCategory = z.infer<typeof expenseCategorySchema>

export interface ExpenseCategoryDraft {
  name: string
  branchIds: string[]
  active: boolean
}

/** Kassa xarajati turlari (ADR-050): bo'sh filiallar — hamma filialda */
export async function fetchExpenseCategories(signal?: AbortSignal): Promise<ExpenseCategory[]> {
  const response = await api.get<unknown>('/api/finance/expense-categories', { ...(signal ? { signal } : {}) })
  return z.array(expenseCategorySchema).parse(response.data)
}

export async function createExpenseCategory(draft: ExpenseCategoryDraft): Promise<ExpenseCategory> {
  const response = await api.post<unknown>('/api/finance/expense-categories', draft)
  return expenseCategorySchema.parse(response.data)
}

export async function updateExpenseCategory(id: string, draft: ExpenseCategoryDraft): Promise<ExpenseCategory> {
  const response = await api.put<unknown>(`/api/finance/expense-categories/${id}`, draft)
  return expenseCategorySchema.parse(response.data)
}
